import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const QUESTIONNAIRES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('QUESTIONNAIRES');
export const QUESTIONNAIRES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	QUESTIONNAIRES_CRUD_ACTION_CONSTANTS
);
